import { useState, useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { environmentAtom } from '../state/atoms'

interface HeaderProps {
  branchName?: string
  userName?: string
  onLogout?: () => void
  onSettings?: () => void
  ratesLastUpdated?: Date | null
  isLoadingRates?: boolean
}

function Header({
  branchName = '강남점',
  userName = 'Demo User',
  onLogout,
  onSettings,
  ratesLastUpdated,
  isLoadingRates
}: HeaderProps) {
  const [currentDate, setCurrentDate] = useState(new Date())
  const environment = useRecoilValue(environmentAtom)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date())
    }, 500)
    return () => clearInterval(timer)
  }, [])

  const dateString = currentDate.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\. /g, '. ')

  const timeString = currentDate.toLocaleTimeString('ko-KR', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })

  return (
    <header
      className={`w-full h-[70px] flex items-center justify-between px-6 ${environment === 'development' ? 'bg-red-500' : 'bg-fx-header'}`}
    >
      {/* Left side */}
      <div className="flex items-center gap-3 h-full py-3">
        <img 
          src='/images/icon/logo_white.png' 
          alt="logo" 
          className="h-full w-auto object-contain" 
        />
        
        <div className="flex items-center ml-2 gap-2">
          <p className="text-white text-sm opacity-80">
            {branchName} | {userName}
          </p>
          {environment === 'development' && (
            <span className="text-white text-xs font-bold bg-red-700 px-2 py-0.5 rounded">
              개발환경
            </span>
          )}
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        <button
          onClick={onSettings}
          className="text-white text-base hover:opacity-80 transition-opacity px-3 py-1"
        >
          ⚙️ 설정
        </button>
        <div className="w-px h-6 bg-white opacity-30" />
        <div className="flex flex-col justify-center">
          <span className="text-white text-base opacity-90">{dateString}</span>
          <span className="text-white text-base font-bold leading-none tabular-nums mt-0.5">
            {timeString}
          </span>
        </div>
        <div className="w-px h-6 bg-white opacity-30" />
        <div className="flex flex-col justify-center">
          <span className="text-white text-xs opacity-70">환율 갱신</span>
          <span className="text-white text-sm font-medium leading-none tabular-nums mt-0.5">
            {isLoadingRates ? '갱신 중...' : ratesLastUpdated
              ? ratesLastUpdated.toLocaleTimeString('ko-KR', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
              : '--:--:--'}
          </span>
        </div>
        <div className="w-px h-6 bg-white opacity-30" />
        <button
          onClick={onLogout}
          className="text-white text-base hover:opacity-80 transition-opacity px-3 py-1"
        >
          로그아웃
        </button>
      </div>
    </header>
  )
}

export default Header
